
<template>
  <!--社区app配置-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="applicationId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <img :style="{width: '30px', height: '30px'}" :src="row.iconUrl" alt="">
      </template>
    </x-tabula>

    <!--同步应用功能的弹窗-->
    <a-modal
      title="同步应用功能"
      :visible="visible"
      @ok="submitForm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="modalConfig"
      width="1000px"
    >
      <x-addEdit
        ref="addEdit"
        formType="modal"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="formList"
        :addParam="addParam"
        :itemLayout="{labelCol: { span: 6 },wrapperCol: { span: 14 }}"
      >
        <template slot="transfer" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required >
            <transfer ref="transfer"/>
          </a-form-item>
        </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect, userRange } from '@/utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
import transfer from '../../views/transfer.vue';
export default {
  mixins: [fetchSelect, addEdit, userRange],
  name: 'application',
  components: {
    transfer
  },
  data () {
    return {
      modalConfig: {
        labelCol: {span: 6},
        wrapperCol: {span: 14}
      },
      appTypeObj: {
        communityApp: { appType: 2 },
        stewardApp: { appType: 1 }
      },
      visible: false,
      btnLoading: { loading: false },

      searchList: [
        { props: ['keywords'], placeholder: '应用名称', inputType: 'input' },
        { props: ['status'], placeholder: '请选择状态', options: this.$store.state.statusList, inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:application:add'] },
        { text: '同步应用功能', icon: 'cloud-download', handle: this.openModal, permi: ['community:application:sync'] }
      ],
      rowOptList: [
        { text: '', customRender: true, handle: row => this.statusChange(row), permi: ['community:application:status'] },
        {
          text: '修改',
          handle: row => {
            this.$refs.table.toEdit(row);
          },
          permi: ['community:application:edit']
        },
        { text: '编辑功能', handle: row => this.toEditFun(row), permi: ['community:appButton:list'] },
        [
          { text: '删除', handle: row => this.$refs.table.showDeleteConfirm(row), permi: ['community:application:remove'] }
        ]
      ],
      columns: [
        { title: '应用名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '应用识别符', dataIndex: 'uniqueMark', align: 'left', width: '' },
        { title: '应用图标', dataIndex: 'icon', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '排序', dataIndex: 'sort', align: 'left', width: '' },
        { title: '应用平台', dataIndex: 'platform', align: 'left', width: '' },
        { title: '默认应用', dataIndex: 'isDefault', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        status: '',
        appType: ''
      },
      listApi: {
        url: '/application/list',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: () => {
          return this.$route.name === 'communityApp' ? 'addCommunityApp' : 'addStewardApp';
        },
        addTitle: '新增app应用',
        editTitle: '修改app应用'
      },
      deleteParam: {
        url: '/application/',
        // param: {pk_key: 'applicationId', pk_val: ''},
        title: '应用',
        key: 'title'
      },

      formList: [
        {
          label: '应用范围',
          inputType: 'select',
          options: this.$store.state.userRange,
          handle: this.handleUserRange,
          placeholder: '请选择应用范围',
          props: ['scopeType', {
            rules: [{required: true, message: '请选择应用范围'}]
          }]
        },
        {
          isShow: false,
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: true,
          key: 'city',
          props: ['cityScope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          slot: 'transfer',
          isShow: false,
          label: '选择小区',
          inputType: 'text',
          options: [],
          placeholder: '',
          titles: ['小区列表', '已选'],
          key: 'community',
          props: ['communityScope', {
            rules: [{required: true, message: '请选择小区'}]
          }]
        }
      ],
      addParam: {
        url: '/application/sync',
        reqHandle: this.addReqHandle,
        resHandle: this.addResHandle
      }
    };
  },
  created () {
    this.searchParams = {...this.searchParams, ...this.appTypeObj[this.$route.name]};
  },
  mounted () {
  },
  methods: {
    submitForm () {
      this.$refs.addEdit.handleSubmit();
    },
    /* 打开弹窗 */
    openModal () {
      this.formList.forEach(item => {
        if (item.props[0] === 'communityScope' || item.props[0] === 'cityScope') {
          item.isShow = false;
        }
      });
      this.visible = true;
      this.$nextTick(() => {
        this.userRangeList(1, 2);
      });
    },
    /* 处理用户范围 */
    handleUserRange (val) {
      let userTypeObj = {
        0: { city: false, community: false },
        1: { city: true, community: false },
        2: { city: false, community: true }
      };
      this.handleDynamicForm(val, userTypeObj);
    },
    /* 状态切换 */
    statusChange (row) {
      let status = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/application/${row.applicationId}`,
        params: { status: status }
      }).then((res) => {
        this.$message.success('切换成功！');
        this.$refs.table.getTableList();
      });
    },
    /* 进入编辑功能 */
    toEditFun (row) {
      let routeObj = {
        communityApp: 'editCommunityFun',
        stewardApp: 'editStewardFun'
      };
      this.setLocal('scopeArray', row.scopeArray);
      this.$router.push({
        name: routeObj[this.$route.name],
        query: {
          id: `${row.applicationId}`,
          android: `${row.android}`,
          ios: `${row.ios}`,
          scopeType: `${row.scopeType}`,
          ...this.breadParam(this)
        }
      });
    },
    addReqHandle (param) {
      let arealist = this.$refs.transfer && this.$refs.transfer.targetKeys;

      if (param.scopeType == 2 && arealist.length == 0) {
        this.$message.error('请选择小区');
        return;
      }
      if (param.scopeType == 2 && arealist.length != 0) {
        param.communityScope = arealist;
      }

      param = this.rangeReqVal(param);
      param = {...param, ...this.appTypeObj[this.$route.name]};
      for (let key in param) {
        if (key === 'scope' || key === 'cityScope' || key === 'communityScope') {
          param[key] = Array.isArray(param[key]) ? param[key].join(',') : param[key];
        }
      }
      return param;
    },
    addResHandle () {
      this.visible = false;
      this.$message.success('同步应用功能成功！');
    },
    resHandle (res) {
      res.forEach((el) => {
        let arr = [];
        el.android && arr.push('Android');
        el.ios && arr.push('iOS');
        el.platform = arr.join(' | ');
        el.isDefault = el.isDefault === 1 ? '是' : '否';
      });
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>
